import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-alert-card',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  templateUrl: './alert-card.component.html',
  styleUrls: ['./alert-card.component.scss']
})
export class AlertCardComponent {
  @Input() message: string = '';
  @Input() translationKey: string = '';
  @Input() dismissible: boolean = false;
  @Input() type: 'success' | 'warning' | 'error' | 'info' | 'ai' | 'primary' | 'secondary' = 'info';
  @Input() buttonText: string = 'Try Now';
  @Output() buttonClick = new EventEmitter<void>();
  
  visible: boolean = true;

  dismiss(): void {
    this.visible = false;
  }
  
  onButtonClick(): void {
    this.buttonClick.emit();
  }
}
